import { Box, makeStyles } from '@material-ui/core'
import { CardInfo } from 'components/CardInfo'
import { BiTimer, BiGroup, BiPackage, BiTrendingUp, BiTrendingDown } from 'react-icons/bi'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '2rem',
    flexWrap: 'wrap',
    '@media (max-width: 1200px)': {
      gap: '0.5rem',
    },
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
})

interface IMetricsRowProps {
  globalAverage: number
  totalUsers: number
  totalItems: number
  bestPerformer: string
  worstPerformer: string
}

export const MetricsRow = (props: IMetricsRowProps) => {
  const { globalAverage, totalUsers, totalItems, bestPerformer, worstPerformer } = props
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <CardInfo
        title="Média Global"
        info={`${globalAverage.toFixed(1)} min`}
        icon={BiTimer}
        color="#2549CC"
      />
      <CardInfo
        title="Separadores Ativos"
        info={totalUsers.toString()}
        icon={BiGroup}
        color="#89BD23"
      />
      <CardInfo
        title="Itens Processados"
        info={totalItems.toLocaleString()}
        icon={BiPackage}
        color="#6ACFD8"
      />
      <CardInfo
        title="Melhor Performance"
        info={bestPerformer}
        icon={BiTrendingUp}
        color="#4CAF50"
      />
      <CardInfo
        title="Pior Performance"
        info={worstPerformer}
        icon={BiTrendingDown}
        color="#FF6B6B"
      />
    </Box>
  )
}
